/**
 * Header Layout
 *
 * @file header.js
 */


const header = (() => {
  const fixedHeader = () => {
    const header = document.querySelector('header');
    if(header){
      window.addEventListener('scroll', () => {
        if(window.scrollY > 50){
          header.classList.add('fixed_header');
        }else{
          header.classList.remove('fixed_header');
        }
      });
    }
  };

  const fullSearchModal = () => {
    const fullSearchModalBtn = document.querySelector('header .header-search');
    const fullSearchModalClose = document.querySelector('.full-search-modal .search-modal-close');
    const fullSearchModal = document.querySelector('.full-search-modal');
    const fullSearchInput = document.querySelector('.search-modal-content input');
    const fullSearchOverlay = document.querySelector('.search-modal-overlay');
    fullSearchModalBtn.addEventListener('click', () => {
      fullSearchModal.classList.add('active');
      document.body.classList.add('u-noscroll');
      setTimeout(() => {
        fullSearchInput.focus();
      }, 100);
    });
    
    fullSearchModalClose.addEventListener('click', () => {
      fullSearchModal.classList.remove('active');
      document.body.classList.remove('u-noscroll');
      fullSearchInput.value = '';
    });
    fullSearchOverlay.addEventListener('click', () => {
      fullSearchModal.classList.remove('active');
      document.body.classList.remove('u-noscroll');
      fullSearchInput.value = '';
    });
  };
  const mobileMenu = () => {
    const mobileNav = document.querySelector('.main-nav');
    const mobileHamburgerMenu = document.querySelector('.mobile-hamburger-menu');
    mobileHamburgerMenu.addEventListener('click', () => {
      mobileHamburgerMenu.classList.toggle('active');
      mobileNav.classList.toggle('mobile-active');
    });
  };
  
  const mobileDetailMenu = () => {
    const mobileDetailMenu = document.querySelector('.mobile-menu-active');
    const mobileDetailMenuNav = document.querySelector('.page-left-menu nav');
    if(mobileDetailMenu){
      mobileDetailMenu.addEventListener('click', () => {
        mobileDetailMenuNav.classList.toggle('mobile-active');
      });
    }
  };

  const megaMenuOverlay = () => {
    const overlay = document.querySelector('.mega-menu-overlay');
    const items = document.querySelectorAll('.main-nav__item');
    if (!overlay || !items.length) return;

    const hasMegaMenu = (item) => !!item.querySelector(':scope > .mega-menu');

    const setActive = (active) => {
      overlay.classList.toggle('active', active);
    };

    items.forEach((item) => {
      if (!hasMegaMenu(item)) return;

      item.addEventListener('mouseenter', () => setActive(true));
      item.addEventListener('mouseleave', () => setActive(false));
    });

    overlay.addEventListener('mouseenter', () => setActive(false));
  };

  const mobileHeaderMenuToggle = () => {
    const mobileHeaderMenu = document.querySelector('.mobile-header-menu');
    if (!mobileHeaderMenu) return;

    mobileHeaderMenu.addEventListener('click', () => {
      document.body.classList.toggle('overflow-hidden');
    });
  };
  
  const pageHasHash = () => {
    const hash = window.location.hash;
    
    if (hash) {
      const targetId = hash.substring(1);
      
        setTimeout(() => {
          const targetElement = document.getElementById(targetId);
          if (targetElement) {
            const elementPosition = targetElement.offsetTop;
            const offsetPosition = elementPosition - 100;
            
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        }, 100);
    }
  };

  const init = () => {
    fixedHeader();
    fullSearchModal();
    mobileMenu();
    mobileDetailMenu();
    megaMenuOverlay();
    mobileHeaderMenuToggle();
    pageHasHash();
  };

  return {
    init,
  };
})();

export default header;
